import { render, staticRenderFns } from "./VideoChannelPlayer.vue?vue&type=template&id=cbe43d3c&scoped=true&"
import script from "./VideoChannelPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoChannelPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe43d3c",
  null
  
)

export default component.exports